import React, { FC } from 'react';
import { Box, LottiePlayerECOMMBX, Skeleton } from '@dxb-web-ui-framework/design-system';
import { ContentProps } from './types';
import { Actions, SuccessInfo } from './';

const MobileContent: FC<ContentProps> = ({
  amount,
  currency,
  numberFormat,
  navigateToDashboard,
  onToggleDetails,
  onToggleTemplate,
  t,
  isLoading,
  isTransactionSettled,
  showTemplateSaveBtn,
  transactionId,
}) => (
  <>
    <Box
      display='flex'
      flexDirection='column'
      justifyContent='space-between'
      alignItems={isLoading ? 'center' : 'unset'}
      width='100%'>
      <Box textAlign='center'>
        <SuccessInfo
          isLoading={isLoading}
          amount={amount}
          currency={currency}
          numberFormat={numberFormat}
          t={t}
          isTransactionSettled={isTransactionSettled}
          transactionId={transactionId}
        />
      </Box>
      <Box
        display='flex'
        justifyContent='center'
        maxWidth={isLoading ? '416px' : '100%'}
        maxHeight='416px'
        width='100%'
        height='100%'
        mt={isLoading ? 3 : 0}>
        {isLoading ? (
          <Skeleton width='100%' height='100%'>
            <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
          </Skeleton>
        ) : (
          <LottiePlayerECOMMBX icon='ecommbx_success' loop play />
        )}
      </Box>
      <Box display='flex' justifyContent='center' width='100%'>
        <Actions
          navigateToDashboard={navigateToDashboard}
          onToggleDetails={onToggleDetails}
          onToggleTemplate={onToggleTemplate}
          t={t}
          isLoading={isLoading}
          showTemplateSaveBtn={showTemplateSaveBtn}
        />
      </Box>
    </Box>
  </>
);

export { MobileContent };
